import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum EditorPlatformManifestServicesErrorCode {
  Internal = 'Internal',
  LoadManifestFromCDNError = 'LoadManifestFromCDNError',
  ManifestUrlNotProvided = 'ManifestUrlNotProvided',
  ContextualManifestAlreadyRegistered = 'ContextualManifestAlreadyRegistered',
  ContextualManifestDoesNotExist = 'ContextualManifestDoesNotExist',
  ManifestResolvingError = 'ManifestResolvingError',
  EditorPointerIsNotResolved = 'EditorPointerIsNotResolved',
  LoadComponentPanelError = 'LoadComponentPanelError',
  ManifestComponentTypeMissing = 'ManifestComponentTypeMissing',
  DefaultValueResolving = 'DefaultValueResolving',
  ManifestContextAPI = 'ManifestContextAPI',
  ManifestQuery = 'ManifestQuery',
  ManifestContextBuild = 'ManifestContextBuild',
  ContextualManifestSelectorNotFound = 'ContextualManifestSelectorNotFound',
  MultipleComponentsSelected = 'MultipleComponentsSelected',
  PlatformComponentsService = 'PlatformComponentsService',
  ExternalAPIHandlers = 'ExternalAPIHandlers',
  ForwardElementPathStrategyNotFound = 'ForwardElementPathStrategyNotFound',
  ElementTraverseNode = 'ElementTraverseNode',
  ManifestAPIProvider = 'ManifestAPIProvider',
  ManifestOverrideResolverError = 'ManifestOverrideResolverError',
  ManifestOverrideResolverWarning = 'ManifestOverrideResolverWarning',
  InvalidBindingKeyFormat = 'InvalidBindingKeyFormat',
  UnsupportedBindingType = 'UnsupportedBindingType',
  PendingAppManifest = 'PendingAppManifest',
  ManifestWaitTimeout = 'ManifestWaitTimeout',
  InvalidManifestType = 'InvalidManifestType',
  ProviderTypeRequired = 'ProviderTypeRequired',
  ProviderManifestNotFound = 'ProviderManifestNotFound',
  ProvidersAPINotAvailable = 'ProvidersAPINotAvailable',
  BindingsAPINotAvailable = 'BindingsAPINotAvailable',
  ProviderComponentDataApi = 'ProviderComponentDataApi',
}

class EditorPlatformManifestServicesError extends BaseError<EditorPlatformManifestServicesErrorCode> {
  constructor(message: string, code: EditorPlatformManifestServicesErrorCode) {
    super(message, code, 'Editor Platform Manifest Services');
  }

  // TODO: should be base method
  withMultipleErrors(errors: Error[]) {
    this.state = {
      ...this.state,
      errors: errors.map((error) => error.message).join(', '),
    };
    return this;
  }

  withComponentType(componentType: string) {
    this.state = {
      ...this.state,
      componentType,
    };
    return this;
  }

  withInnerElementPath(elementPath: string[] | undefined) {
    const innerElementPath = elementPath ? elementPath.join(' ') : '';
    this.state = {
      ...this.state,
      innerElementPath,
    };
    return this;
  }

  withWarnings(warnings: { path: string; reason: string; message: string }[]) {
    this.state = {
      ...this.state,
      warningCount: String(warnings.length),
      warningReasons: [
        ...new Set(warnings.map((warning) => warning.reason)),
      ].join(','),
    };

    warnings.forEach((warning, index) => {
      this.withMessage(
        `[warning:${index + 1}]`,
        `path=${warning.path}`,
        `reason=${warning.reason}`,
        `message=${warning.message}`,
      );
    });

    return this;
  }
}

export const createEditorPlatformManifestServicesError = createErrorBuilder<
  EditorPlatformManifestServicesErrorCode,
  EditorPlatformManifestServicesError
>(EditorPlatformManifestServicesError);
